import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { InputCurrency } from '@sm360/ui-library'

import { Context } from '../../../../configs/state.manager'

const InvoiceItem = ({ slug, label, amount, isCardLayout }) => {
    const {
        state: {
            dealerInfos: { lang },
        },
    } = React.useContext(Context)

    const classNames = clsx('pc-invoiceItem', slug && `-${slug}`, isCardLayout && '-card')

    return (
        <div className={classNames}>
            <span className='pc-invoiceItem__label'>{label}</span>

            <span className='pc-invoiceItem__value'>
                <InputCurrency id={slug} name={slug} value={amount} displayAsText displayWithTwoDecimals locale={lang} />
            </span>
        </div>
    )
}

InvoiceItem.propTypes = {
    slug: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    amount: PropTypes.number,
    isCardLayout: PropTypes.bool,
}

InvoiceItem.defaultProps = {
    slug: '',
    label: '',
    amount: null,
    isCardLayout: false,
}

export default InvoiceItem
